// Índice das usinas da Vigor (nome curto ↔ números da UC geradora), para as
// listas do Financeiro mostrarem a usina de cada associado. A regra está em
// `src/lib/financeiro/usinaDaFatura.ts`; aqui fica só a busca.
//
// Falha de rede ou RLS (papéis de parceira não leem o rateio) NÃO derruba a
// tela: o índice fica vazio e as colunas de usina ficam em branco.

import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { indiceDeUsinas, INDICE_VAZIO, type IndiceUsinas } from '../lib/financeiro/usinaDaFatura';

export function useIndiceUsinas(): IndiceUsinas {
  const [indice, setIndice] = useState<IndiceUsinas>(INDICE_VAZIO);

  useEffect(() => {
    let vivo = true;
    supabase
      .from('rateio_unidades_geradoras')
      .select('id, nome, ativo, numero_uc_geradora, numero_uc_geradora_antigo')
      .then(({ data, error }) => {
        if (error) {
          console.warn('Não foi possível carregar as usinas; as listas ficam sem a coluna de usina.', error);
          return;
        }
        if (vivo) setIndice(indiceDeUsinas(data || []));
      });
    return () => { vivo = false; };
  }, []);

  return indice;
}
